import * as columns from './columns'

angular.module('clientDashboardApp')
  .directive('listingAccuracyLocationTable', () => {
    return {
      restrict: 'E',
      scope: {
        getFilters: '=',
      },
      template: require('./locationTable.html'),
      controller: ($scope, $timeout, $q, listingService) => {

        $scope.columns = columns.locationColumns
        $scope.isLoadingInitial = true;
        $scope.isLoadingSort = false;
        $scope.isLoadingMore = false;
        $scope.list = [];
        $scope.hasMore = false;
        $scope.sortDirection = 1;
        $scope.sortCol = $scope.columns[0];
        let sortedResults = undefined;
        let cursor = 0;
        const pageSize = 30;


        const reset = () => {
          $scope.isLoadingInitial = true;
          $scope.isLoadingSort = false;
          sortedResults = undefined;
          fetchLocationDetails(0, pageSize).then(result => {
            $scope.isLoadingInitial = false;
            $scope.isLoadingMore = false;
            $scope.hasMore = result.hasMore;
            $scope.list = result.items;
            cursor = pageSize;

            if ($scope.sortCol !== $scope.columns[0] || $scope.sortDirection !== 1) { // if the sort is default, let it be
              $scope.sortLocationTable($scope.sortCol, false);
            }
          })


        }

        const fetchLocationDetails = (skip = 0, limit = pageSize) => {
          const { groupId, params } = $scope.getFilters();
          return listingService
            .listingAccuracyReportByLocation(groupId, {
              ...params,
              skip,
              limit
            })
            .then(r => r.data)
        }


        $scope.sortLocationTable = (col, toggle = true) => {
          if (!$scope.isLoadingSort) {
            $scope.isLoadingSort = true;
            if ($scope.sortCol === col) {
              if (toggle) {
                $scope.sortDirection = $scope.sortDirection * -1;
              }
            } else {
              $scope.sortCol = col;
              $scope.sortDirection = 1;
            }
            loadRemainingLocationDetails()
              .then((all) => {
                if (col === $scope.sortCol && $scope.isLoadingSort) {
                  sortedResults = all.sort((a, b) => {
                    return col.sort(a[col.key], b[col.key]) * $scope.sortDirection
                  });

                  $scope.isLoadingSort = false;
                  $scope.list = sortedResults.slice().slice(0, cursor);


                }
              })
          }

        }


        $scope.locationDetailsNextPage = () => {
          if (!$scope.isLoadingMore && $scope.hasMore) {
            $scope.isLoadingMore = true;
            const inMemory = sortedResults && {
              items: sortedResults.slice(cursor, cursor + pageSize),
              hasMore: sortedResults.length > cursor + pageSize
            }
            const promise = inMemory ? $q.resolve(inMemory) : fetchLocationDetails(cursor, pageSize);
            return promise.then(result => {
              if ($scope.isLoadingMore) {
                cursor = cursor + pageSize;
                $scope.isLoadingMore = false;
                $scope.list.push(...result.items);
                $scope.hasMore = result.hasMore;
              }
            })
          } else {
            return $q.resolve(undefined)
          }
        }

        const loadRemainingLocationDetails = () => {
          if (sortedResults) {
            return $q.resolve(sortedResults)
          } else if (!$scope.hasMore && !$scope.isLoadingInitial) {
            return $q.resolve($scope.list.slice())
          } else {
            const loop = (myCursor, soFar) => {
              let batch = 1000;
              return fetchLocationDetails(myCursor, batch).then(result => {
                if (!$scope.isLoadingSort) {
                  return $q.reject("sort interrupted")
                } else if (!result.hasMore) {
                  return $q.resolve(soFar.concat(result.items))
                } else {
                  return loop(myCursor + batch, soFar.concat(result.items))
                }
              })
            }
            return loop(cursor, $scope.list.slice())
          }
        };
        $scope.$on('listingAccuracy:reset', reset)
        reset()
      }
    }
  })
